import { _ } from "../../core/polyglot/polyglot.js";
import AccountingDocument from "../shared/documentInfrastructure/AccountingDocument2/AccountingDocument.js";
import ComparisonToolDocumentActions from "./document/ComparisonToolDocumentActions/ComparisonToolDocumentActions.js";
import ComparisonToolDocumentContent from "./document/ComparisonToolDocumentContent/ComparisonToolDocumentContent.js";
import ComparisonToolDocumentCoordinator from "./document/ComparisonToolDocumentCoordinator.js";
import ComparisonToolDocumentService from "./document/ComparisonToolDocumentService.js";
import ComparisonToolDocumentState from "./document/ComparisonToolDocumentState.js";
import ForecastLoadingWidget from "../../core/widgets/ForecastLoadingWidget/ForecastLoadingWidget.js";
import session from "../../core/session.js";
import TitleWidget from "../../core/chrome/TitleWidget2.js";

/**
 * Todo: Add JSDoc comment
 */
export function makeComparisonToolDocument() {
	const company = session.getCompany();
	const chartOfAccountsId = session.getCurrentChartOfAccountsId();
	const period = session.getPeriod();

	const coordinator = new ComparisonToolDocumentCoordinator({
		session,
		documentState: new ComparisonToolDocumentState({
			period,
			service: new ComparisonToolDocumentService({
				company,
				period,
				chartOfAccountsId,
				session,
			}),
		}),
		renderables: {
			content: new ComparisonToolDocumentContent(),
			title: new TitleWidget({ title: _("Comparison Tool") }),
			actions: new ComparisonToolDocumentActions({
				company,
				period,
			}),
		},
	});

	return new AccountingDocument({
		coordinator,
		spinner: new ForecastLoadingWidget({
			title: _("Get ready to compare numbers"),
			subtitle: _("Your data is loading…"),
		}),
	});
}
